module.exports = __webpack_public_path__ + "23109cdbacabbf62240e1b7591eae422.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/error-robot-2.png
// module id = 253
// module chunks = 1